
































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { maxFileSize } from "@/tool/validation";
import { VForm } from "@/common/vuetify_types";

@Component
export default class EditPopUpFileInput extends Vue {
  @Ref("form") form!: VForm;
  @Prop() label!: string;
  @Prop() title!: string;
  @Prop() loading!: boolean;
  editValue = "";
  fileError = "";
  fileURL: string | ArrayBuffer | null | undefined = "";
  uploadedFiles: File | null = null;
  clr = 0;

  formDataURL() {
    const reader = new FileReader();
    if (this.uploadedFiles) {
      reader.onload = (event: ProgressEvent<FileReader>) => {
        this.fileURL = event.target?.result;
      };
      reader.readAsDataURL(this.uploadedFiles);
    }
  }

  onChangeFile(event: File) {
    if (this.uploadedFiles) this.uploadedFiles = null;
    const validSize = maxFileSize(event, 5);
    if (validSize !== true) {
      this.fileError = validSize;
      return true;
    }
    this.uploadedFiles = event;
    this.formDataURL();
  }

  close() {
    this.clr++;
    this.fileError = "";
    this.$emit("close");
  }

  save() {
    if (this.form.validate()) {
      this.clr++;
      this.fileError = "";
      this.$emit("save", this.uploadedFiles);
    }
  }
}
